import { render, staticRenderFns } from "./AppCommentList.vue?vue&type=template&id=3a546952&scoped=true&"
import script from "./AppCommentList.vue?vue&type=script&lang=js&"
export * from "./AppCommentList.vue?vue&type=script&lang=js&"
import style0 from "./AppCommentList.vue?vue&type=style&index=0&id=3a546952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a546952",
  null
  
)

export default component.exports